// Mention utilities
export interface MentionSelection {
  name: string;
  userId: string;
}

/** Build a queue map of name -> userId[] to handle duplicates deterministically. */
export function buildMentionQueue(mentions: MentionSelection[]): Map<string, string[]> {
  const map = new Map<string, string[]>();
  mentions.forEach((m) => {
    const arr = map.get(m.name) ?? [];
    arr.push(m.userId);
    map.set(m.name, arr);
  });
  return map;
}

/**
 * Convert display text to structured text using the selected mentions.
 * Replaces only as many occurrences as we have selections for each name.
 */
export function buildStructuredComment(text: string, mentions: MentionSelection[]): string {
  if (mentions.length === 0 || text.length === 0) return text;
  const queue = buildMentionQueue(mentions);
  let i = 0;
  let result = '';
  const distinctNames = Array.from(queue.keys());
  while (i < text.length) {
    if (text[i] === '@') {
      let matched = false;
      for (let n = 0; n < distinctNames.length; n += 1) {
        const name = distinctNames[n];
        const candidate = '@' + name;
        if (text.startsWith(candidate, i)) {
          const afterIdx = i + candidate.length;
          const boundary = afterIdx === text.length || /\s/.test(text[afterIdx]);
          const ids = queue.get(name) ?? [];
          if (boundary && ids.length > 0) {
            const userId = ids.shift() as string; // safe due to length check
            queue.set(name, ids);
            result += `@[${name}](user:${userId})`;
            i = afterIdx;
            matched = true;
            break;
          }
        }
      }
      if (matched) continue;
    }
    result += text[i];
    i += 1;
  }
  return result;
}
